// File: admin-callback.component.ts
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs';
import { AdminAuthService } from '../../service/admin-auth.service';
import { AdminCommonHttpService } from '../../service/admin-common-http.service';
import { RbacService } from '../../service/rbac.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-admin-callback',
  standalone: true,
  template: '<p>Signing in...</p>',
})
export class AdminCallbackComponent implements OnInit {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
    private authService: AdminAuthService,
    private commonApiService: AdminCommonHttpService,
    private rbacService: RbacService
  ) { }


  async ngOnInit(): Promise<void> {
    const { isAuthenticated, userData, accessToken, idToken } =
      await firstValueFrom(
        this.oidcSecurityService.checkAuth().pipe(take(1))
      );

    console.log('Auth callback complete. Authenticated:', isAuthenticated);
    console.log('User Data:', userData);

    if (!isAuthenticated || !userData) {
      this.authService.logout();
      this.router.navigate(['/login']);
      return;
    }

    localStorage.setItem('admin_user_sub', userData['sub']);
    localStorage.setItem('admin_access_token', accessToken);
    localStorage.setItem('x-id-token', idToken);

    const tenant = await this.commonApiService.getTenant();
    if (!tenant) {
      this.authService.logout();
      return;
    }

    const tenantId = tenant.tenant_id;
    const userEmail = userData['email'];

    let username = userData['username'] || 'User';
    username = username.charAt(0).toUpperCase() + username.slice(1).toLowerCase();

    this.authService.login(username, userEmail, tenantId);

    await this.rbacService.loadRolesAndPolicies();
    await this.authService.resolvePlatformAdmin();
    await this.authService.resolveTenantAdmin();


    if (tenant.name) {
      this.authService.setTenantName(tenant.name);
    }

    localStorage.setItem('is_admin', 'true');

    this.router.navigate(['/admin/home']);
  }

}
